import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Gamepad from '../../GamePad';
import Ps4Layout from '../../GamePad/layouts/PS4';
import ArrowsBackground from '../Ps4Share/ArrowsBackground';
import ArrowsBorder from '../Ps4Share/ArrowsBorder';
import ButtonsBackground from '../Ps4Share/ButtonsBackground';
import DownArrow from '../Ps4Share/DownArrow';
import L1Button from '../Ps4Share/L1Button';
import L2Button from '../Ps4Share/L2Button';
import LeftArrow from '../Ps4Share/LeftArrow';
import LeftLegBorder from '../Ps4Share/LeftLegBorder';
import LeftStick from '../Ps4Share/LeftStick';
import LeftStickBackground from '../Ps4Share/LeftStickBackground';
import LeftStickBorder from '../Ps4Share/LeftStickBorder';
import OButton from '../Ps4Share/OButton';
import OptionsButton from '../Ps4Share/OptionsButton';
import PsButton from '../Ps4Share/PsButton';
import R1Button from '../Ps4Share/R1Button';
import R2Button from '../Ps4Share/R2Button';
import RightArrow from '../Ps4Share/RightArrow';
import RightLegBorder from '../Ps4Share/RightLegBorder';
import RightStick from '../Ps4Share/RightStick';
import RightStickBackground from '../Ps4Share/RightStickBackground';
import RightStickBorder from '../Ps4Share/RightStickBorder';
import Speaker from '../Ps4Share/Speaker';
import ShareButton from '../Ps4Share/ShareButton';
import SquareButton from '../Ps4Share/SquareButton';
import TouchPad from '../Ps4Share/TouchPad';
import TriangleButton from '../Ps4Share/TriangleButton';
import UpArrow from '../Ps4Share/UpArrow';
import XButton from '../Ps4Share/XButton';

import Body from './components/Body';

const STICK_OFFSET = 30;

function ControllerPs4Ore({ data, styles }) {
  const [gamepad, setGamepad] = useState({
    ...Ps4Layout.buttonsDefault,
    ...Ps4Layout.axisDefault,
  });
  const { player } = data;

  const axisChangeHandler = (axisName, value) => {
    setGamepad((prevState) => ({ ...prevState, [axisName]: value }));
  };
  const buttonChangeHandler = (buttonName, value) => {
    setGamepad((prevState) => ({ ...prevState, [buttonName]: value }));
  };

  return (
    <>
      <Gamepad
        gamepadIndex={player}
        layout={Ps4Layout}
        onButtonChange={buttonChangeHandler}
        onAxisChange={axisChangeHandler}
      >
        <svg
          width="800"
          height="600"
          viewBox="0 0 800 600"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <R2Button
            activeColor={styles.active.color}
            color={styles.backButtons.background}
            value={gamepad.RightTrigger}
          />
          <R1Button
            active={gamepad.R1}
            activeColor={styles.active.color}
            color={styles.backButtons.background}
          />
          <L1Button
            active={gamepad.L1}
            activeColor={styles.active.color}
            color={styles.backButtons.background}
          />
          <L2Button
            activeColor={styles.active.color}
            color={styles.backButtons.background}
            value={gamepad.LeftTrigger}
          />
          <Body />
          <LeftLegBorder color={styles.legs.background} />
          <RightLegBorder color={styles.legs.background} />
          <ArrowsBackground color={styles.arrows.background} opacity={0.7} />
          <ButtonsBackground color={styles.buttons.background} opacity={0.7} />
          <LeftStickBackground color={styles.sticks.background} opacity={0.7} />
          <g
            style={{
              transform: `translateX(${
                gamepad.LeftStickX * STICK_OFFSET
              }px) translateY(${-gamepad.LeftStickY * STICK_OFFSET}px)`,
            }}
          >
            <LeftStickBorder
              active={gamepad.L3}
              activeColor={styles.active.color}
              color={styles.sticks.border}
            />
            <LeftStick
              active={gamepad.L3}
              activeColor={styles.active.color}
              color={styles.sticks.color}
            />
          </g>
          <RightStickBackground
            color={styles.sticks.background}
            opacity={0.7}
          />
          <g
            style={{
              transform: `translateX(${
                gamepad.RightStickX * STICK_OFFSET
              }px) translateY(${-gamepad.RightStickY * STICK_OFFSET}px)`,
            }}
          >
            <RightStickBorder
              active={gamepad.R3}
              activeColor={styles.active.color}
              color={styles.sticks.border}
            />
            <RightStick
              active={gamepad.R3}
              activeColor={styles.active.color}
              color={styles.sticks.color}
            />
          </g>
          <TriangleButton
            active={gamepad.Triangle}
            activeColor={styles.active.color}
            color={styles.buttons.color}
          />
          <OButton
            active={gamepad.O}
            activeColor={styles.active.color}
            color={styles.buttons.color}
          />
          <XButton
            active={gamepad.X}
            activeColor={styles.active.color}
            color={styles.buttons.color}
          />
          <SquareButton
            active={gamepad.Square}
            activeColor={styles.active.color}
            color={styles.buttons.color}
          />
          <UpArrow
            active={gamepad.UpArrow}
            activeColor={styles.active.color}
            color={styles.arrows.color}
          />
          <RightArrow
            active={gamepad.RightArrow}
            activeColor={styles.active.color}
            color={styles.arrows.color}
          />
          <LeftArrow
            active={gamepad.LeftArrow}
            activeColor={styles.active.color}
            color={styles.arrows.color}
          />
          <DownArrow
            active={gamepad.DownArrow}
            activeColor={styles.active.color}
            color={styles.arrows.color}
          />
          <ArrowsBorder color={styles.arrows.border} />
          <PsButton
            active={gamepad.Ps}
            activeColor={styles.active.color}
            background={styles.ps.background}
            color={styles.ps.color}
          />
          <Speaker />
          <TouchPad
            active={gamepad.TouchPad}
            activeColor={styles.active.color}
            color={styles.touchpad.background}
          />
          <OptionsButton
            active={gamepad.Options}
            activeColor={styles.active.color}
            color={styles.options.background}
          />
          <ShareButton
            active={gamepad.Share}
            activeColor={styles.active.color}
            color={styles.options.background}
          />
          <path
            d="M463 178.496C463 202.174 445.74 218 421.581 218H378.419C354.799 218 337 202.174 337 178.496C337 154.932 354.26 139 378.419 139H421.574C445.732 139.015 463 154.917 463 178.496ZM438.842 178.496C438.842 168.895 431.83 161.368 421.581 161.368H378.419C368.178 161.368 361.166 168.895 361.166 178.496C361.166 188.211 368.178 195.632 378.419 195.632H421.574C431.822 195.632 438.834 188.234 438.834 178.496H438.842Z"
            fill="white"
            fillOpacity="0.9"
          />
          <path
            d="M387 183L400.004 170L413 183H387Z"
            fill="#E6007E"
            fillOpacity="0.9"
          />
        </svg>
      </Gamepad>
    </>
  );
}

ControllerPs4Ore.propTypes = {
  data: PropTypes.shape({
    player: PropTypes.number,
  }),
  styles: PropTypes.shape({
    active: PropTypes.shape({
      color: PropTypes.string,
    }),
    arrows: PropTypes.shape({
      color: PropTypes.string,
      background: PropTypes.string,
      border: PropTypes.string,
    }),
    backButtons: PropTypes.shape({
      background: PropTypes.string,
    }),
    buttons: PropTypes.shape({
      background: PropTypes.string,
      color: PropTypes.string,
    }),
    legs: PropTypes.shape({
      background: PropTypes.string,
    }),
    options: PropTypes.shape({
      background: PropTypes.string,
    }),
    ps: PropTypes.shape({
      background: PropTypes.string,
      color: PropTypes.string,
    }),
    sticks: PropTypes.shape({
      background: PropTypes.string,
      border: PropTypes.string,
      color: PropTypes.string,
    }),
    touchpad: PropTypes.shape({
      background: PropTypes.string,
    }),
  }),
};

ControllerPs4Ore.defaultProps = {
  data: {
    player: 0,
  },
  styles: {
    active: {
      color: '#fff',
    },
    arrows: {
      color: '#4F535E',
      background: '#000000',
      border: '#E6007E',
    },
    backButtons: {
      background: '#000201',
    },
    buttons: {
      background: '#000000',
      color: '#464A56',
    },
    legs: {
      background: '#E6007E',
    },
    options: {
      background: '#4F535F',
    },
    ps: {
      background: '#030303',
      color: '#E6007E',
    },
    sticks: {
      background: '#32353A',
      border: '#393E42',
      color: '#32353A',
    },
    touchpad: {
      background: '#1A1B1F',
    },
  },
};

export default ControllerPs4Ore;
